import { createAsyncThunk, AnyAction } from "@reduxjs/toolkit"
import { ThunkDispatch } from "redux-thunk"

import i18n from "config/i18n"
import { API } from "redux/api"

export const fetchPaymentScheduleAttachment = createAsyncThunk(
  "payment-schedule-attachment/fetch",
  async (values: { payment_schedule_id: string }) => {
    const response = await API.get(
      `/payment_schedules/${values.payment_schedule_id}/download`,
    )
    return response.data
  },
)

export const makeDownloadPaymentSchedule = ({
  payment_schedule_id,
}: {
  payment_schedule_id: string
}) => {
  return function (dispatch: ThunkDispatch<unknown, unknown, AnyAction>) {
    return new Promise<{ url: string }>((resolve, reject) => {
      return dispatch(fetchPaymentScheduleAttachment({ payment_schedule_id }))
        .then(
          ({ payload }) => {
            if (!payload) {
              return reject(
                i18n.t("notice.payment_schedule.download.unavailable"),
              )
            }

            if (payload?.attachment) {
              const { attachment } = payload

              if (attachment?.file?.url) {
                resolve({ url: attachment.file.url })
              }
            }
          },
          () => {
            reject(i18n.t("notice.payment_schedule.download.failure"))
          },
        )
        .catch((error) => {
          reject(error)
        })
    })
  }
}
